var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    width: 505,
    height: 984,
    x: 0,
    y: -552
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,21c-0.2,0-0.5-0.1-0.7-0.3l-9-8C0.1,12.6,0,12.3,0,12s0.1-0.6,0.3-0.7l9-8c0.3-0.3,0.7-0.3,1.1-0.2 C10.8,3.2,11,3.6,11,4v5c0,0.6-0.4,1-1,1S9,9.6,9,9V6.2L2.5,12L9,17.8V15c0-0.6,0.4-1,1-1s1,0.4,1,1v5c0,0.4-0.2,0.8-0.6,0.9 C10.3,21,10.1,21,10,21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,21c-0.4,0-0.8-0.2-0.9-0.6c0,0-2-4.4-12.1-4.4c-0.6,0-1-0.4-1-1s0.4-1,1-1c6.1,0,9.6,1.5,11.6,2.9 C19.5,10.1,10.4,10,10,10c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.1,0,14,0.1,14,12c0,0.5-0.3,0.9-0.8,1C23.1,21,23.1,21,23,21z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.ccdf414d878d8c22d10260a34c7ef454.svg";
export { ForwardRef as ReactComponent };